
import { PropTypes } from 'prop-types';
import Secondary from "./secondary";
import PreUniversity from "./preUniversity";

const EducationLevel = ({ level, handleAllowNext }) => {
    return (

        level === 0 ?
            <Secondary handleAllowNext={handleAllowNext} />
            :
            <PreUniversity handleAllowNext={handleAllowNext}/>
    )
}

EducationLevel.propTypes = {
    level: PropTypes.any,
    handleAllowNext: PropTypes.any,

}
export default EducationLevel